export default "__VITE_PUBLIC_ASSET__eba8ccd5__"